import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

class ReturnModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            message: ""
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleChange = (event) => {
        this.setState({
            message: event.target.value
        }, this.validate)
    }

    handleClose = () => {
        this.props.handleClose();
    }

    handleConfirm = () => {
        this.validate();

        if (this.state.messageError) {
            return;
        }

        this.props.handleConfirm(this.state.message);
        this.props.handleClose();
    }

    // OTHER METHODS

    validate = () => {
        if (this.state.message.length > 255) {
            this.setState({
                messageError: true
            });
        }
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onRequestHide={() =>{}} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">Return floating task</h4>
                        </div>
                        <div className="modal-body">
                            <label>Message:</label>
                            <textarea className="form-control" value={this.state.message} onChange={this.handleChange} />
                        </div>
                        <div className="modal-footer">
                            <button title="Return floating task" ref="deleteButton" type="button" className="btn btn-default btn-large" onClick={this.handleConfirm}>Return</button>
                            <button title="Cancel return" ref="closeButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>

        );
    }
}

ReturnModal.propTypes = {
    taskName: PropTypes.string,
    handleClose: PropTypes.func
};

export default connect()(ReturnModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/ReturnModal.js
 **/